import React, { useState, useEffect } from 'react';
import { WHATS_NEW } from '../whatsNew';

/**
 * WhatsNewModal — one-time "מה חדש" popup after login. Controlled by
 * WHATS_NEW.enabled (src/whatsNew.js); shown once per user per version via a
 * per-account localStorage flag.
 */
function WhatsNewModal({ user }) {
  const seenKey = user ? `kup-whatsnew-seen-${user.id}` : null;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!WHATS_NEW.enabled || !seenKey) return;
    try {
      if (localStorage.getItem(seenKey) !== WHATS_NEW.version) setOpen(true);
    } catch { /* storage unavailable */ }
  }, [seenKey]);

  if (!open) return null;

  const dismiss = () => {
    try { localStorage.setItem(seenKey, WHATS_NEW.version); } catch {}
    setOpen(false);
  };

  return (
    <>
      <div onClick={dismiss} style={{ position: 'fixed', inset: 0, zIndex: 900, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(2px)' }} />
      <div style={{
        position: 'fixed', zIndex: 901, top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 'min(480px, calc(100vw - 32px))', maxHeight: 'calc(100vh - 64px)', overflowY: 'auto',
        background: 'var(--surf)', borderRadius: 20, boxShadow: 'var(--shadow)',
        padding: '26px 24px 20px', direction: 'rtl', fontFamily: 'Heebo, sans-serif',
        animation: 'fadeUp .25s ease',
      }}>
        <div style={{ fontSize: 26, textAlign: 'center', marginBottom: 6 }}>🎉</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--txt)', textAlign: 'center', marginBottom: 18 }}>
          {WHATS_NEW.title}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {WHATS_NEW.items.map((it, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <span style={{
                fontSize: 15, width: 30, height: 30, borderRadius: 9, background: 'var(--accent-bg)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              }}>{it.icon}</span>
              <span style={{ fontSize: 13.5, color: 'var(--txt)', lineHeight: 1.45, paddingTop: 4 }}>{it.text}</span>
            </div>
          ))}
        </div>
        <button onClick={dismiss} style={{
          marginTop: 22, width: '100%', padding: '11px 0', borderRadius: 12, border: 'none',
          background: 'var(--accent)', color: '#fff', fontSize: 14, fontWeight: 700,
          fontFamily: 'Heebo, sans-serif', cursor: 'pointer',
        }}>הבנתי, קחו אותי למערכת</button>
      </div>
    </>
  );
}

export default WhatsNewModal;
